import { BoxProps, ButtonProps } from '@chakra-ui/react';
import { useState } from 'react';
import { useNavigatorPermission } from '../../hooks/useNavigatorPermission';
import { copyToClipboard } from '../../utils';
import { MBox } from './chakra';
import MButton from './MButton';
import MText from './MText';

export interface CopyToClipboardButtonProps {
  value: string;
  beforeCopyText?: string;
  afterCopyText?: string;
  buttonProps?: ButtonProps;
  /** If copy to clipboard is not available or fails, link is shows as text */
  showLinkProps?: BoxProps;
}

export function CopyToClipboardButton({
  value,
  beforeCopyText = 'Copy Link',
  afterCopyText = 'Copied',
  buttonProps,
  showLinkProps,
}: CopyToClipboardButtonProps) {
  const { canCopyClipboard } = useNavigatorPermission();

  const [isCopied, setIsCopied] = useState(false);
  const [showValue, setShowValue] = useState(false);

  const handleCopyLinkToClipboard = async (
    ev: React.MouseEvent<HTMLElement>,
  ) => {
    ev.stopPropagation();
    const didCopy = await copyToClipboard(value);
    if (!didCopy) {
      setShowValue(true);
      return;
    }
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  };

  if (!value) {
    return null;
  }

  if (!canCopyClipboard || showValue) {
    return (
      <MBox {...showLinkProps}>
        <MText>{value}</MText>
      </MBox>
    );
  }

  return (
    <MButton
      variant="tertiary"
      size="sm"
      onClick={handleCopyLinkToClipboard}
      fontStyle={isCopied ? 'italic' : undefined}
      minW="86.1px"
      {...buttonProps}
    >
      {isCopied ? afterCopyText : beforeCopyText}
    </MButton>
  );
}
